<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />
 
  <div class="page">
    <div class="formgrid grid form-file">
      <div class="field col-12">
        <div class="button-wrapper">
          <span :class="['label', {'active': fileToUpload.length > 0}]">
            {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Carica File' }}
          </span>
          <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
        </div>
        <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
        <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
        <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
      </div>
    </div>

    <div class="report" v-if="report && Object.keys(report).length">
      <h4>Report</h4>
      <div class="mt-2">
        <DataTable :value="report" tableStyle="width: 100%">
            <Column field="fornitura" header="Fornitura" />
            <Column field="data" header="Mese">
              <template #body="{data}">
                {{formatDate(data.month)}}
              </template>
            </Column>
            <Column field="errore" header="Errore" />
        </DataTable>
      </div>
    </div>


  </div>

      
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance} from 'vue';
// import Service from '@/services/ask-operation/operation-service'
import UtilityService from '@/services/ask-management/utility-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
   data: {
      type: Object,
      required: true

    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'pods-carica-consumi'}
    const loader = ref(false)
    const toast = useToast();
    
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    // const service = new Service(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const fileToUpload = ref([])
    const allowedType = {
      'xls' : 'application/vnd.ms-excel',
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    } 
    const type_fornitura = ref(props.data.type)
    const report = ref()
    const validationErrors = ref({})
    const submitted = ref(false)
  

    const handleFileUpload = (evt) => {
      fileToUpload.value = []
      evt.preventDefault()
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
    }
      
    const onOkButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) {
        report.value = null
        loader.value = true 
        utilityService.caricamentoConsumiFile(fileToUpload.value, type_fornitura.value)
        .then((res) => {
          toast.add({severity:'success', summary: 'Importazione', detail:res.items.msg});
          if (res.items.errors.length > 0) {
            report.value = res.items.errors
          }
        })
        .finally(()=>{
          fileToUpload.value = []
          loader.value = false
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    
    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const validateForm = () => {

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => (Object.values(allowedType).join(',').replace(';',',').split(",").includes(file.type)), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      type_fornitura,
      fileToUpload,
      allowedType,
      loader,
      handleFileUpload,
      report,
      validationErrors, 
      submitted,
      onCancelButton,
      onOkButton,
      formatDate
    }
  }
}


</script>

<style scoped>
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

</style>

